<template>
 
</template>

<script>
export default {
  components: {},

  data() {
    return {};
  },
  props: ["item", "index", "selectedIndex"],
  methods: {},
};
</script>

<style>

.group-hd .left .min-name {
    margin-right: 5px;
    font-size: 15px;
    line-height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/views/page/tabbar/diy/model/SupplyInfo.vue